module.exports = __webpack_public_path__ + "static/media/oriental-insurance.65e9ae2e.png";